<template>
	<div v-if="isUserAllowedInLevel5or6 || isUserAllowedInLevel1">
		<BaseHeader :title="$t('connect_pro_app').toString()" :subtitle="$t('scan_qr_code_to_download_connect_app').toString()"/>
		<div v-if="!isLoading" class="main">
			<div class="w-full grid grid-cols-2">
				<div class="w-full">
					<div>
						<img src="../../../assets/qr-code-ipad.svg" alt="QR Code Connect Assist iOS" class="w-128" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'ConnectApp',
	components: { Forbidden, BaseHeader },
	mixins: [Authentication],
	data() {
		return {
			isLoading: false,
		};
	},
	mounted() {},
	methods: {},
};
</script>
